import { Layout } from '../../../layout/layout.types';

export type Scheme = 'auto' | 'dark' | 'light';
export type Screens = { [key: string]: string };
export type Theme = 'theme-default' | string;

export interface ThemeConfig {
	layout: Layout;
	scheme: Scheme;
	screens: Screens;
	theme: Theme;
}

export const THEME_CONFIG: ThemeConfig = {
	layout: 'thin',
	scheme: 'auto',
	screens: {
		sm: '600px',
		md: '960px',
		lg: '1280px',
		xl: '1440px',
	},
	theme: 'theme-brand',
};
